import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const teamId = localStorage.getItem("team_id");

  return teamId ? element : <Navigate to="/" />;
};

export default ProtectedRoute;
